import React, { useEffect } from 'react';
import { Alert, ErrorScreen } from 'components/common';
import { useInventory, useUser, useList } from 'components/hooks';
import { ROUTES } from 'consts';
import { formatProjectItems } from 'helpers';
import withRequest from 'hoc/withRequest';
import { useHistory, withRouter } from 'react-router-dom';
import { InventorySchema } from 'schemas';
import { CircularProgress, Backdrop } from '@mui/material';
import InventoryFormDumb from './InventoryFormDumb';


const InventoryCreateSmart = () => {
  const companies = useList('companies');
  const history = useHistory();
  const { cleanUpMessage, error, success, postInventory } = useInventory();

  const defaultValues = {
    name: '',
    description: '',
    type: 'Form',
    fileType: 'ini',
    additionalVariables: '',
    company: '',
    tags: [],
    hosts: [],
    hostGroups: [],
    childrenGroups: [],
    modalHostName: '',
  };

  const handleCloseAlert = () => cleanUpMessage();

  const handleCreate = (data) => {

    const hostGroups = data.hostGroups.map(g => {
      delete g.hostToShow;
      return g;
    });

    const childrenGroups = data.childrenGroups.map(c => {
      delete c.groupsToShow;
      return c;
    });

    const dataSave = {
      name: data.name,
      description: data.description,
      type: data.type,
      file_type: data.fileType,
      additional_variables: data.additionalVariables,
      company: data.company,
      tags: data.type === "Form" ? data.tags : [],
      hosts: data.type === "Form" ? data.hosts : [],
      host_groups: data.type === "Form" ? hostGroups : [],
      children_groups: childrenGroups,
      fromEdit: false
    }
    postInventory({ body: dataSave });
  };

  useEffect(() => {
    if (!!success.post) history.push(ROUTES.INVENTORY_LIST);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.post]);

  useEffect(() => {
    companies.getContentList({ query: {}});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      { companies.error ?
        (
          <ErrorScreen />
        ): companies.isLoaded ?
        (
          <Backdrop
            invisible
            sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
            open={true}
          >
            <CircularProgress color="primary" />
          </Backdrop>
        ): (companies.content) ?
        (
          <InventoryFormDumb
            defaultValues={defaultValues}
            handleOnSubmit={handleCreate}
            companies={companies.content.map((i) => ({ value: i.company_id, label: i.name }))}
            isEdit={false}
          />
        )
        :(
          <ErrorScreen />
        )
      }
      <Alert severity="error" handleClose={handleCloseAlert} open={error.post} message="common.errors.general.title" />
    </>
  );
};

export default withRequest(withRouter(InventoryCreateSmart));
